$(document).ready(function() {
    var servicePartnerSearchPageContainer = $(".service-partner-search-page").first();
    if (!servicePartnerSearchPageContainer.length) {
        return;
    }

    //append divs in created divs for service partner page
    $(".icons-search-mp").wrap("<div id='wrapper_search-mp'>");
    $(".icons-make-appointment").wrap("<div id='wrapper_appointment'>");
    $(".icons-mount-tire").wrap("<div id='wrapper_mount-tire'>");
    var toggleElement = $(".toggle-content");
    toggleElement.has("div.first-child").appendTo("#wrapper_search-mp");
    toggleElement.has("div.second-child").appendTo("#wrapper_appointment");
    toggleElement.has("div.last-child").appendTo("#wrapper_mount-tire");
});